import Vue from 'vue';
import api from './api.mjs';
import trace from './trace.mjs';
import FormErrors from './components/form-errors';
import FormErrorList from './components/form-error-list';
import { dialogBoxManager } from "./dialogs/manager";
import { LoginDialog } from "./dialogs/login-dialog.mjs";
import { PriceListDialog } from "./dialogs/price-list.mjs";
import { callManualUpdate } from './dom';
import { mediaQueryState } from "./responsive.mjs";
import {
    attribute,
    attributeInt,
    attributeString,
    formatPostcode,
    formErrorComputed,
    formErrorData,
    formErrorMethods,
    isPostcode,
    secondsToTime,
} from "./helpers";
import {pushEvent} from "./analytics.mjs";

window.toggleServiceExpanded = function (event, index, category, display_type='flex') {
    event.preventDefault();
    const element = event.target.closest('.box.prices');
    const expandedContent = element.querySelector('.expanded-content');
    const closedOnly = element.querySelector('.closed-only');
    const openOnly = element.querySelector('.open-only');

    if (expandedContent.style.display === 'none' || !expandedContent.style.display) {
        expandedContent.style.display = display_type;
        closedOnly.style.display = 'none';
        openOnly.style.display = 'inline';
    } else {
        expandedContent.style.display = 'none';
        closedOnly.style.display = 'inline';
        openOnly.style.display = 'none';
    }
}
window.selectOption = function(selectOption) {
    const selectOptionsElement = document.getElementById('deal_' + selectOption);
    const selectOptions = document.querySelectorAll('.deal-option');

    selectOptions.forEach((option) => {
        if (option === selectOptionsElement) {
            option.style.display = 'block';
        } else {
            option.style.display = 'none';
        }
    });
};
window.searchGarment = function(searchValueInput) {
    const searchValue = searchValueInput.toLowerCase().trim();
    if (searchValue == "") {
        const allSections = document.querySelectorAll('.expanded-content');
        allSections.forEach((section) => {
            section.style.display = 'none';
        });
        return false;
    }
    const boxes = document.querySelectorAll('.price-section');

    const allSections = document.querySelectorAll('.expanded-content');
    allSections.forEach((section) => {
        section.style.display = 'none';
     });
    let scrolled = false;
    const modal_content = document.querySelector('.modal-content');

    boxes.forEach((box) => {
        box.style.fontWeight = 'normal';
        const boxHolderParent = box.parentNode;
        const boxParent = boxHolderParent.parentNode;

        const expandedContent = box.closest('.expanded-content');
        const boxHeader = boxParent.querySelector('.card-header');
        const closedOnly = boxParent.querySelector('.closed-only');
        const openOnly = boxParent.querySelector('.open-only');

        const boxText = box.textContent.toLowerCase();
        if (boxText.includes(searchValue)) {
            box.style.fontWeight = 'bold';
            if (expandedContent) {
                expandedContent.style.display = 'block';
                closedOnly.style.display = 'none';
                openOnly.style.display = 'inline';
                console.log(scrolled);
                if (!scrolled) {
                    scrolled = true;
                    modal_content.scrollTo({
                        top: boxHeader.parentNode.offsetTop,
                        behavior: 'smooth'
                    });
                }

            }

        }
    });
};

const componentDefinition = {
    components : {
        'form-errors'     : FormErrors,
        'form-error-list' : FormErrorList
    },
    data : {
        ...formErrorData,

        // Basic order properties
        customer_id : null,
        location_id : null,

        service : null,
        locker  : null,

        // Instructions section
        instructions : '',
        voucher      : '',

        postcode : '',

        // 'Your Details' (new Customer)
        firstname : '',
        surname   : '',
        email     : '',
        phone     : '',
        apartment : '',

        // Choose a password,
        password         : '',
        password_confirm : '',
        marketing: 0,

        check_tc   : false,
        check_news : false,

        locationLoading : false,
        locationLoaded  : false,
        locationError   : false,
        location        : null,

        pricesLoading : false,
        pricesLoaded  : false,

        customerLoading : false,
        customerError   : false,
        customer        : null,

        orderSubmitting : false,

        remainingStandard : false,
        remainingExpress  : false,

        returnStandard : '',
        returnExpress  : '',
        returnNoRush  : '',

        signupRoute : "orderRouteDefault",

        tickTimer : null,
    },
    computed : {
        ...formErrorComputed,

        // Customer
        hasCustomer() {
            return !! this.customer_id;
        },

        // Location
        hasLocation() {
            return !! this.location_id;
        },
        locationAddress() {
            // Use postcode from search rather than location's postcode
            return this.location ? [ ...this.location.address, this.postcode ].join(', ') : '';
        },
        locationName() {
            return this.location ? this.location.name : '';
        },
        locationLockers() {
            return this.location ? this.location.lockers : [];
        },
        canChangeLocation() {
            return ! this.customer;
        },

        // Placing deadlines
        timeTillCutoffStandard() {
            return secondsToTime( this.remainingStandard );
        },
        timeTillCutoffExpress() {
            return secondsToTime( this.remainingExpress );
        },

        //
        // Visibility State Control
        //

        // Location Visibility
        showLocationSearch() {
            return ! this.locationLoaded;
        },
        showLocationFound() {
            return this.locationLoaded && this.location;
        },
        showLocationNotFound() {
            return this.locationLoaded && ! this.location;
        },
        showLockerField() {
            return ! ( this.location && this.location.concierge );
        },

        // Customer Visibility
        showCustomerIncomplete() {
            return ! this.location;
        },
        showCustomerEntry() {
            return this.location && ! this.customer;
        },
        showCustomerComplete() {
            return !! this.customer;
        },

        // Order Visibility
        showOrderIncomplete() {
            return ! this.customer;
        },
        showOrderEntry() {
            return ( this.customer && this.location );
        }


    },
    methods : {
        ...formErrorMethods,

        // Event Triggers (Clicks, Input changes, etc)
        callLoginDialog : function( event ) {
            if( mediaQueryState.isMobile() )
                return true;

            event.preventDefault();
            dialogBoxManager.pushDialog( new LoginDialog() );
            return false;
        },
        callPriceListDialog : function( event ) {
            if( mediaQueryState.isMobile() ) {
                //return true;
            }
            event.preventDefault();
            //check and hide if is logged in user
           let need_first_order = event.target.getAttribute("need-first-order");
           console.log("need_first_order", need_first_order);

            // Show the loading icon before the fetch call
            this.pricesLoading = true;
            this.pricesLoaded  = false;
            fetch('/popup-prices')
                .then(response => response.text())
                .then(content => {
                    let need_first_orderDialog = false;
                    if (need_first_order == "yes") {
                        need_first_orderDialog = true;
                    }
                    let contentDialog = {
                        prices: content,
                        need_first_order: need_first_orderDialog
                    };

                    dialogBoxManager.pushDialog( new PriceListDialog(contentDialog) );

                })
                .finally( () => {
                    this.pricesLoading = false;
                    this.pricesLoaded  = true;
                });

            return false;
        },

        onCreateAccount( event ) {
            event.preventDefault();

            if( this.customerLoading )
                return;

            const requestBody = {
                location         : this.location.location_id,
                postcode         : this.postcode,
                email            : this.email,
                phone            : this.phone,
                surname          : this.surname,
                firstname        : this.firstname,
                apartment        : this.apartment,
                password         : this.password,
                password_confirm : this.password_confirm,
                marketing_consent: this.marketing,
            };

            this.clearAllErrors();
            this.customerLoading = true;

            api.createCustomerForOrderForm( requestBody )
                .then( response => {
                    trace.log( 'API response', response );

                    // This will be processed in the event of a success result, but also
                    // in the event of a validation fail. The two outcomes can be determined
                    // by the state of the response.result boolean value.
                    if( response.result ) {
                        if (this.signupRoute === "create-account") {
                            window.location = "/home/next-steps";
                        }
                        console.log('success!', response);
                        this.customer = response.customer;
                    } else {
                        this.populateValidationErrors( response );
                    }
                })
                .catch( error => {
                    // abnormal response
                    console.error( 'error', error );
                })
                .finally( () => {
                    this.customerLoading = false;
                })
            ;
        },

        onLocationChange( event ) {
            event.preventDefault();

            this.location        = null;
            this.locationLoaded  = false;
            this.locationLoading = false;
            this.postcode        = null;
        },

        onOrderSubmit( event ) {
            event.preventDefault();

            if( this.orderSubmitting )
                return;

            const requestBody = {
                customer     : this.customer.customer_id,
                location     : this.location.location_id,
                concierge    : this.location.concierge ? 1 : 0,
                locker       : this.locker,
                service      : this.service,
                instructions : this.instructions,
                voucher      : this.voucher,
                check_tc     : this.check_tc ? 1 : 0
            };

            this.orderSubmitting = true;
            this.clearAllErrors();

            api.submitOrder( requestBody )
                .then( response => {
                    if( response.result ) {
                        // We use pathname to stop any possible redirection hijacks.
                        // This way, it can only redirect internally.
                        window.location.pathname = response.next;
                    } else {
                        this.populateValidationErrors( response );
                    }
                })
                .finally( () => {
                    this.orderSubmitting = false;
                })
            ;
        },

        onPostcodeSearch( event ) {
            event.preventDefault();

            if( ! this.postcode )
                return false;

            if( ! isPostcode(this.postcode) ) {
                return this.setErrors( 'postcode', [
                    'Please enter a valid postcode'
                ]);
            }

            this.postcode = formatPostcode( this.postcode );
            this.clearErrors('postcode');

            this.locationLoading = true;
            this.locationLoaded  = false;

            api.getLocationForPostcode( this.postcode )
                .then( location => {
                    this.populateLocation( location );
                    callManualUpdate();
                    this.startTick();
                })
                .catch( error => console.error('error', error) )
                .finally( () => {
                    this.locationLoading = false;
                    this.locationLoaded  = true;
                })
            ;
        },

        populateLocation( properties ) {
            this.location       = properties;
            this.location_id    = properties.location_id;
            this.postcode       = properties.postcode;

            // noinspection JSUnresolvedVariable
            this.returnStandard    = properties?.deadlines?.delivery_standard;
            // noinspection JSUnresolvedVariable
            this.returnExpress     = properties?.deadlines?.delivery_express;
            // noinspection JSUnresolvedVariable
            this.returnNoRush     = properties?.deadlines?.delivery_no_rush;
            // noinspection JSUnresolvedVariable
            this.remainingStandard = properties?.deadlines?.remaining_standard;
            // noinspection JSUnresolvedVariable
            this.remainingExpress  = properties?.deadlines?.remaining_express;

            this.locationLoaded = true;
        },

        populateValidationErrors( response ) {
            const errors = response.errors || {};
            trace.warn( 'Validation errors', errors, response );

            for( let index in errors ) {
                this.setErrors( index, errors[index] );
            }
        },

        // Internals

        startTick() {
            if( this.tickTimer )
                clearInterval( this.tickTimer );

            if( ! this.remainingStandard && ! this.remainingExpress )
                return;

            this.tickTimer = setInterval( () => {
                this.remainingStandard--;
                this.remainingExpress--;
            }, 1000 );
        },
    },
    beforeMount: function() {

        /* Because this form is designed to work statically (based on values inserted
         * into the page at generation) and dynamically (based on values obtained
         * through API calls or component properties) we will need to check at mount
         * time to see if we are being passed any models as part of the page render.
         *
         * If we are, we need to populate them into the component data fields/
         */
        let customer, location;

        // noinspection JSAssignmentUsedAsCondition
        if( customer = attribute(this.$el, 'data-customer') ) {
            const properties = JSON.parse( customer );
            if( properties ) {
                this.customer    = properties;
                this.customer_id = properties.customer_id;
                trace.info( 'Place order: customer parsed', properties );
            } else {
                trace.warn( 'Place order: unable to parse customer', customer );
            }
        }

        // noinspection JSAssignmentUsedAsCondition
        if( location = attribute(this.$el, 'data-location') ) {
            const properties = JSON.parse( location );
            if( properties ) {
                this.populateLocation( properties );
                trace.info( 'Place order: location parsed', properties );
            } else {
                trace.warn( 'Place order: unable to parse location', location );
            }
        }

        this.service  = attributeInt(    this.$el, 'data-service'  );
        this.postcode = attributeString( this.$el, 'data-postcode' );
        this.signupRoute = attributeString( this.$el, 'data-signupRoute' );
        if( this.postcode ) {
            // If we have a postcode at mount time, it means the back-end
            // has handled the location lookup. We need to let the form
            // know that the location has 'loaded' in order to show the
            // 'no location'.
            this.locationLoaded = true;
            trace.info( 'Place order: postcode present', this.postcode );
        } else {
            trace.warn( 'Place order: no postcode present');
        }
    },
    mounted: function() {
        this.startTick();
    },
}

const target_id      = 'place-order-form';
const target_element = document.getElementById(target_id);

target_element && new Vue({
    ...componentDefinition,
    el: target_element
});
